module.exports = __webpack_public_path__ + "static/media/journal3.9a0cc37b.png";